import { runtimeEnv } from 'config/runtimeEnv';
// src/services/ConsolidatedInvoiceService.js
import requestInstance from './Request';

const BASE_URL = `${runtimeEnv('B2B_API_BASE_URL')}/billing/v2`;

const consolidatedInvoiceService = {
  // POST: Generate consolidated invoice for multi-day extension
  async generateConsolidatedInvoice(parentTripId) {
    try {
      const payload = {
        parentTripId: parentTripId,
      };

      const response = await requestInstance.post(
        `${BASE_URL}/consolidated/multi-day-extension`,
        payload,
      );

      console.log('Consolidated Invoice Response:', response);
      return response.data;
    } catch (error) {
      console.error('Error generating consolidated invoice:', error);
      throw error;
    }
  },

  async sendConsolidatedInvoiceEmail(invoiceId, recipients) {
    try {
      const payload = {
        recipients: recipients,
      };

      const response = await requestInstance.post(
        `${BASE_URL}/consolidated-invoice/${invoiceId}/send-email`,
        payload,
      );

      return response.data;
    } catch (error) {
      console.error('Error sending invoice email:', error);
      throw error;
    }
  },
};

export default consolidatedInvoiceService;
